<template>
    <div class="street-box">
        <i
            class="iconfont icon-street map-tool"
            :style="css"
            @click="click"
        ></i>
        <div ref="street" v-show="streetShow" class="street-container"></div>
    </div>
</template>
<script>
import util from '../../../common/util';
import Base from './base';
export default {
    mixins: [Base],
    data: function() {
        return {
            streetShow: false
        };
    },
    methods: {
        handler([map, maps]) {
            util.getMapPs().then(() => {
                const center = map.getCenter();
                const position = {
                    lat: center.lat,
                    lng: center.lng
                };
                if (this.panorama) {
                    this.setStreetView(position, point => {
                        this.panorama.setPosition(point);
                        this.streetShow = true;
                        this.$nextTick(() => {
                            this.panorama.setVisible(true);
                        });
                    });
                } else if (this.$refs && this.$refs.street) {
                    this.setStreetView(position, point => {
                        this.streetShow = true;
                        this.panorama =
                            new window.google.maps.StreetViewPanorama(
                                this.$refs.street,
                                {
                                    position: point,
                                    enableCloseButton: true
                                }
                            );
                        this.panorama.addListener('closeclick', () => {
                            this.panorama.setVisible(false);
                            this.streetShow = false;
                        });
                    });
                }
            });
        },
        setStreetView(center, callBack) {
            new window.google.maps.StreetViewService().getPanorama(
                {
                    location: center
                },
                (streetViewPanoramaData, status) => {
                    if (status === window.google.maps.StreetViewStatus.OK) {
                        const point = streetViewPanoramaData.location.latLng;
                        callBack(point);
                    } else {
                        util.toast('Sorry! Street View is not available.');
                    }
                }
            );
        }
    }
};
</script>

<style lang="scss">
.street-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>
